import * as React from 'react';
import { Fragment } from 'react';
import { observer } from 'mobx-react';
import { inject } from '../utils';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '../utils/propStyles';
import Translate from './Translate';
import HTag from './HTag';
import { computed, observable } from 'mobx';
import { LinkFilter } from '../models/configuration/LinkFilter';
import DynamicLink from './DynamicLink';
import { camelCase } from '@kurtosys/ksys-app-template/dist/utils/changeCase';
import { AccessibilityStore, DataStore, EntityStore } from '../stores';
import { DynamicLinkConfig } from '../models/configuration/components/DynamicLinkConfig';

const FundManagerExtendedItems = styled<any, any>('ul')`
    ${propStyles};
`;

FundManagerExtendedItems.defaultProps = {
    listStyle: 'none',
};

const FundManagerExtendedItem = styled<any, any>('li')`
    ${propStyles};
`;

FundManagerExtendedItem.defaultProps = {};

const FundManagerExtendedItemText = styled<any, any>('p')`
    ${propStyles};
`;

FundManagerExtendedItemText.defaultProps = {};

const FundManagerBiography = styled<any, any>('p')`
    ${propStyles};
`;

FundManagerBiography.defaultProps = {
    color: 'body',
    fontFamily: 'body',
    fontWeight: 'regular',
    fontSize: 'sm',
    marginY: 'sm',
};

const FundManagerLink = styled<any, any>('a')`
    ${propStyles};
`;

FundManagerLink.defaultProps = {
    display: 'block',
    color: 'link',
    fontFamily: 'heading',
    fontWeight: 'bold',
    fontSize: 'xs',
    hover: {
        color: 'linkHover',
    },
};

interface FundManagerContentProps {
    theme?: any;
    fundManager: {
        name: string;
        biography: string;
        extended: Array<{
            label: string;
            value: string;
        }>;
        link: {
            label: string;
            value: string;
        };
        url?: string | LinkFilter;
    };
    accessibilityStore?: AccessibilityStore;
    dataStore?: DataStore;
    entityStore?: EntityStore;
}

@inject('dataStore', 'accessibilityStore', 'entityStore')
@observer
class FundManagersContent extends React.Component<FundManagerContentProps> {
    autoPlayId: number;
    @observable activeSlide: number = 0;

    @computed
    get clientCode() {
        const { entityStore } = this.props;
        return entityStore.value.clientCode;
    }

    @computed
    get dynamicLinkConfig(): DynamicLinkConfig {
        const { url } = this.props.fundManager;

        return {
            url,
        };
    }

    @computed
    get dynamicLink(): React.ReactNode {
        const { link } = this.props.fundManager;
        const { theme } = this.props;
        return (
            <DynamicLink
                config={this.dynamicLinkConfig}
                {...theme.FundCardLink}
                fundManager={this.props.fundManager}
                metricContext={`fundManager-${camelCase(this.clientCode)}`}
                ariaLabelKey={'fundManagerLink'}
                onClick={this.onClick}
            >
                <Translate>{link.label}</Translate>
                {/* The url will pull the links text from the links config */}
            </DynamicLink>
        );
    }

    @computed
    get fundManagerLink(): React.ReactNode {
        const { link } = this.props.fundManager;
        const { theme, accessibilityStore } = this.props;

        return (
            <FundManagerLink
                href={link.value}
                onClick={() => this.onClick(link.value)}
                data-metric-id={`fundManager-link-${this.clientCode}`}
                aria-label={accessibilityStore.linkAccessibilityValue(
                    'fundManagerLink'
                )}
                {...theme.FundManagerLink}
            >
                <Translate>{link.label}</Translate>
            </FundManagerLink>
        );
    }

    @computed
    get linkComponent(): React.ReactNode {
        const { url } = this.props.fundManager;
        if (url) {
            return this.dynamicLink;
        } else {
            return this.fundManagerLink;
        }
    }

    onClick = (link: string) => {
        const { dataStore, fundManager } = this.props;
        dataStore.logDataLayer('redirect_to_fund_manager_bio', {
            fundManager: (fundManager as any).context || fundManager,
            clientCode: this.clientCode,
            redirectLink: link,
        });
    };

    render() {
        const { fundManager, theme } = this.props;

        return (
            <Fragment>
                <HTag
                    componentTheme={'FundManagerName'}
                    defaultStyleProps={{
                        color: 'body',
                        fontFamily: 'heading',
                        fontWeight: 'bold',
                        fontSize: 'sm',
                        textAlign: ['left', 'center'],
                        marginY: 'sm',
                    }}
                    level={4}
                    text={fundManager.name}
                />
                {fundManager.extended && fundManager.extended.length > 0 && (
                    <FundManagerExtendedItems
                        {...theme.FundManagerExtendedItems}
                    >
                        {fundManager.extended.map((extended, extendedIndex) => (
                            <FundManagerExtendedItem
                                key={extendedIndex}
                                {...theme.FundManagerExtendedItem}
                            >
                                {extended.label && (
                                    <FundManagerExtendedItemText
                                        {...theme.FundManagerExtendedItemLabel}
                                    >
                                        <Translate>{extended.label}</Translate>
                                    </FundManagerExtendedItemText>
                                )}
                                <FundManagerExtendedItemText
                                    {...theme.FundManagerExtendedItemValue}
                                >
                                    <Translate>{extended.value}</Translate>
                                </FundManagerExtendedItemText>
                            </FundManagerExtendedItem>
                        ))}
                    </FundManagerExtendedItems>
                )}
                {fundManager.biography && (
                    <FundManagerBiography {...theme.FundManagerBiography}>
                        {fundManager.biography}
                    </FundManagerBiography>
                )}
                {this.linkComponent}
            </Fragment>
        );
    }
}

export default withTheme(FundManagersContent) as any;



// WEBPACK FOOTER //
// ./src/Components/FundManagerContent.tsx